// libs
import { motion, Variants } from "framer-motion";
// components
import { Box } from "../Box";
import Button from "../Button";
import { CheckBoxPill } from "../CheckboxPill";
import { Divider } from "../Divider";
import { FlexContainer, FlexItem } from "../Flex";
// other
import { CheckBoxState } from "../../models/client/checkbox-state";
import { easings } from "../../styles/utils";

interface MenuFiltersProps {
  dateState: CheckBoxState[];
  themeState: CheckBoxState[];
  onDatesChange: React.ChangeEventHandler<HTMLInputElement>;
  onThemesChange: React.ChangeEventHandler<HTMLInputElement>;
  onSubmit: React.MouseEventHandler<HTMLButtonElement>;
}

const navVariants: Variants = {
  initial: {
    y: -40,
    opacity: 0,
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: { duration: 1.2, ease: easings.easeOutCubic },
  },
  exit: {
    y: 40,
    opacity: 0,
    transition: { duration: 0.3, ease: easings.easeOutCubic },
  },
};

const dividerVariants: Variants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: { duration: 0.8, delay: 0.4 },
  },
  exit: {
    opacity: 0,
    transition: { duration: 0.3, ease: easings.easeOutCubic },
  },
};

function MenuFilters({
  dateState,
  themeState,
  onDatesChange,
  onThemesChange,
  onSubmit,
}: MenuFiltersProps) {
  return (
    <motion.div initial="initial" animate="animate" exit="exit">
      <motion.div variants={navVariants}>
        <FlexContainer>
          <FlexItem flex={"0 0 33%"}>
            <FlexContainer as="ul" flexWrap="wrap" m={-1}>
              {dateState.map((dateRange) => (
                <FlexItem as="li" key={dateRange.key} flex="0 0 100%" p={1}>
                  <CheckBoxPill
                    name="year"
                    color={dateRange.color}
                    value={dateRange.key}
                    checked={dateRange.checked}
                    onChange={onDatesChange}
                  >
                    {dateRange.label}
                  </CheckBoxPill>
                </FlexItem>
              ))}
            </FlexContainer>
          </FlexItem>
          <FlexItem flex={"0 0 33%"}>
            <FlexContainer as="ul" flexWrap="wrap" m={-1}>
              {themeState.map((category) => (
                <FlexItem key={category.key} as="li" p={1} flex="0 0 100%">
                  <CheckBoxPill
                    name="categories"
                    color={category.color}
                    value={category.key}
                    checked={category.checked}
                    onChange={onThemesChange}
                  >
                    {category.label}
                  </CheckBoxPill>
                </FlexItem>
              ))}
            </FlexContainer>
          </FlexItem>
        </FlexContainer>
      </motion.div>
      <motion.div variants={dividerVariants}>
        <Divider my={4} />
        <Box textAlign="right">
          <Button icon="arrowForward" onClick={onSubmit}>
            Show results
          </Button>
        </Box>
      </motion.div>
    </motion.div>
  );
}

export default MenuFilters;
